import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/trailer',
  title: '拖车管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
